import { makeStyles } from "@mui/styles";

export const surveyStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
    color: '#004F9F',
    width: '100%',
    marginRight: 5
  },
  border: {
    border: '1px solid #004F9F',
    borderRadius: 4,
    marginBottom: 4,
    paddingLeft: 40
  },
  box: {
    width: '100%',
    display: 'flex',
  },
  regularBox: {
    backgroundColor: 'white'
  },
  bad: {
    //background: 'rgb(255,255,255)',
    background: 'linear-gradient(125deg, rgba(255,255,255,1) 90%, rgba(246,104,94,1) 100%)'
  },
  regular: {
    //background: 'rgb(255,255,255)',
    background: 'linear-gradient(125deg, rgba(255,255,255,1) 90%, rgba(246,255,169,1) 100%)'
  },
  good: {
    //background: 'rgb(255,255,255)',
    background: 'linear-gradient(125deg, rgba(255,255,255,1) 90%, rgb(165, 255, 168) 100%)'
  },
  iconG: {
    color: '#4caf50'
  },
  iconB: {
    color: '#f6685e'
  },
  text: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 4,
    marginRight: 20
  }
}));